import { Divider, DividerProps } from "@mui/material";

export type SHDividerProps = DividerProps;
export const SHDivider = (props: SHDividerProps): JSX.Element => (
  <Divider {...props} />
);
